import { coreApi } from '$api'
import { singletonQueryClient } from '$utils'
import { ShiftRequest } from '$models'

enum QueryKeys {
  ShiftRequest = 'shift-request',
}

/**
 * Get a shift request by id, with its lifecycle actions, for the manager's detail panel.
 */
export const getById = async (id: string): Promise<ShiftRequest> => {
  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.ShiftRequest, id],
    queryFn: async () => coreApi.getShiftRequestById(id),
  })
}
